import { flow } from 'lodash';
import { NAME } from './dialogs.constant';

import { selectState as selectStateCheckout } from '../checkout.selector';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateCheckout, selectStateKey);
